import { filter, get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectAnnouncements = state => searchEntities(
  state,
  'announcements',
  ['title', 'description', 'propertyName']
);
